module.exports = __webpack_public_path__ + "img/typhoon_32_40.c8545e46.jpg";